import { IconReactionType } from "@/API";

export class Reaction {
}
